import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography } from "@mui/material";
import ContactInfoBox from "./ContactInfo";
import TicketsBox from "./TicketsBox";

export default function SuportPage() {
  return (
    <>
      <MobileHeader title={getHeaderTitle()} />
      <Box
        sx={{
          paddingX: "8px",
        }}
      >
        {/* <InfoBox /> */}
        <ContactInfoBox />
        <TicketsBox />
      </Box>
    </>
  );
}

function getHeaderTitle() {
  return (
    <Typography
      sx={{
        fontWeight: 600,
        color: "secondary.main",
        fontSize: 16,
      }}
    >
      تیکت{" "}
    </Typography>
  );
}
